export const normalizeGender = (value?: string | null) => {
	if (!value) {
		return '';
	}

	const normalized = value.trim().toLowerCase();

	if (normalized === 'lady' || normalized === 'female') {
		return 'female';
	}

	if (normalized === 'man' || normalized === 'male') {
		return 'male';
	}

	return normalized;
};

export const isSameGender = (
	left?: string | null,
	right?: string | null,
) => normalizeGender(left) !== '' && normalizeGender(left) === normalizeGender(right);
